// extracted by mini-css-extract-plugin
export default {"authorizedList":"modalList_authorizedList__IO1dx","listContainer":"modalList_listContainer__SH4qQ"};